// extracted by mini-css-extract-plugin
export default {"Maincontainer":"CopyRight_Maincontainer__z9mrs","Container":"CopyRight_Container__PaCB4","Logos":"CopyRight_Logos__9yCuu"};